import * as yup from "yup";
import type { Schema } from "yup";

export interface INotificationFormValues {
  title: string;
  message: string;
  centers: string[];
  segments: string[];
  profiles: string[];
  startAt: string; // ISO ou datetime-local
  endAt: string;
  imageUrl?: string | null;
}

export const notificationFormSchema = yup
  .object({
    title: yup.string().trim().required("Título é obrigatório"),
    message: yup.string().trim().required("Mensagem é obrigatória"),

    centers: yup
      .array()
      .of(yup.string().trim().required())
      .min(1, "Selecione pelo menos um centro")
      .default([]),

    segments: yup
      .array()
      .of(yup.string().trim().required())
      .min(1, "Selecione pelo menos um segmento")
      .default([]),

    profiles: yup
      .array()
      .of(yup.string().trim().required())
      .min(1, "Selecione pelo menos um perfil")
      .default([]),

    startAt: yup.string().required("Vigência inicial é obrigatória"),
    endAt: yup
      .string()
      .required("Vigência final é obrigatória")
      .test(
        "end-after-start",
        "A vigência final não pode ser menor que a inicial",
        function (value) {
          const { startAt } = this.parent as INotificationFormValues;

          if (!startAt || !value) return true;

          const start = new Date(startAt);
          const end = new Date(value);

          if (Number.isNaN(start.getTime()) || Number.isNaN(end.getTime())) {
            return true;
          }

          return end >= start;
        }
      ),

    imageUrl: yup.string().nullable().optional(),
  })
  .required() as Schema<INotificationFormValues>;

// valores inicial do formulario de notification
export const formInitialValues: INotificationFormValues = {
  title: "",
  message: "",
  centers: [],
  segments: [],
  profiles: [],
  startAt: "",
  endAt: "",
  imageUrl: null,
};
